/* eslint-disable unicorn/no-null */
import type { FlexProps } from '@chakra-ui/react';
import { Box, Button, Flex, Image } from '@chakra-ui/react';
import { useScrollToTop } from './hooks';

interface IScrollToTopButtonProps extends FlexProps {}

export const ScrollToTopButton: React.FC<IScrollToTopButtonProps> = (props): JSX.Element | null => {
  const { isVisible, scrollToTop } = useScrollToTop();
  return isVisible ? (
    <Flex {...props}>
      <Box w={{ base: 75, md: 94 }}>
        <Button onClick={scrollToTop}>
          <Image alt="scroll-top" src="/images/scroll-up.svg" />
        </Button>
      </Box>
    </Flex>
  ) : null;
};
